import { TranslationDictionary } from '../Models/TranslationDictionary';

type Num = number | undefined | null;

export function dictDeserializer(input: string): TranslationDictionary {
    return JSON.parse(input);
}

export function getCurrentLanguage(): string {
    const htmlNode = document.querySelector('html');
    if (htmlNode) {
        return htmlNode.lang;
    }

    return 'fr';
}

const numberFormatter = new Intl.NumberFormat('de');
export const formatNumber = _formatFn(numberFormatter);

const numberWithSignFormatter = new Intl.NumberFormat('de', {
    signDisplay: 'always',
});
export const formatNumberWithSign = _formatFn(numberWithSignFormatter);

export function formatPercentage(value: Num, digits = 1) {
    const decimalFormatter = new Intl.NumberFormat('de', {
        minimumFractionDigits: digits,
    });

    return _formatFn(decimalFormatter)(value, true);
}

export function formatPercentageWithSign(value: Num, digits = 1) {
    const formatter = new Intl.NumberFormat('de', {
        signDisplay: 'always',
        minimumFractionDigits: digits,
    });

    return _formatFn(formatter)(value, true);
}

function _formatFn(
    formatter: Intl.NumberFormat
): (value: Num, isPercentage?: boolean) => string {
    return (value: Num, isPercentage: boolean = false) => {
        if (!value) {
            return isPercentage ? '0\xa0%' : '0';
        }

        const formatted = formatter.format(value);
        return isPercentage ? `${formatted}\xa0%` : formatted;
    };
}
